import React from 'react';
import { Formik } from 'formik';
import { Form as SForm } from 'semantic-ui-react';
import * as Lookups from '../../../Hooks/LookupOptions';
import { AdditionalInfoSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { AdditionalInfoSearchSchema } from './AdditionalInfoForm.Schema';
import SemanticFormikSelect from '@app/components/React/Common/Forms/SemanticFormikSelect';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';

interface Props {
  currentParams: AdditionalInfoSearchDto;
  setCurrentParams: (p: AdditionalInfoSearchDto) => void;
}

export default function AdditionalInfoForm({ currentParams, setCurrentParams }: Props) {
    const { items: COUNTRY_OPTIONS } = Lookups.useCountryOptions({ defaultValue: currentParams.nationality });
    const { items: SEX_OPTIONS } = Lookups.useSexOptions({ defaultValue: currentParams.sex });
    const discriminator = SEARCH_TYPES_NAMES.AdditionalInfoSearchDto;

    const initialValues: AdditionalInfoSearchDto = {
        discriminator,
        operator: currentParams.operator,
        nationality: currentParams.nationality,
        sex: currentParams.sex,
        fbiNumber: currentParams.fbiNumber || '',
    };

    const handleSubmit = (values: AdditionalInfoSearchDto) => {
        setCurrentParams({ ...values, discriminator });
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={AdditionalInfoSearchSchema}
            onSubmit={handleSubmit}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
        >
            {({ handleSubmit }) => (
                <FormWithButtons handleSubmit={handleSubmit}>
                    <SForm.Group widths="equal">
                        <SemanticFormikSelect
                            name="nationality"
                            label="Nationality"
                            placeholder="Enter nationality"
                            options={COUNTRY_OPTIONS}
                        />
                        <SemanticFormikSelect
                            name="sex"
                            label="Sex"
                            placeholder="Select sex"
                            options={SEX_OPTIONS}
                        />
                        <SemanticFormikInput
                            name="fbiNumber"
                            label="FBI Number"
                            placeholder="Enter FBI number"
                        />
                    </SForm.Group>
                </FormWithButtons>
            )}
        </Formik>
    );
}
